import {
  FETCH_ENTITLEMENTS_SUCCESS,  
  SET_ENTITLEMENT_ID,
  UPDATE_PERSON_ENTITLEMENT,
  CANCEL_PERSON_ENTITLEMENT,
  ADD_PERSON_ENTITLEMENT,
  DELETE_PERSON_ENTITLEMENT,
  RESET_ENTITLEMENT
} from 'actions/types'

import { entitlements, entitlementAdd, entitlementUpdate, entitlementCancel, entitlementDelete } from '../api'
import {
  dataFailure,
  dataSuccess,
} from "./general";

const fetchEntitlementsSuccess = (Entitlements) => {
  return {
    type: FETCH_ENTITLEMENTS_SUCCESS,
    payload: Entitlements
  }
}
 
export const fetchEntitlements = () => {
  return async (dispatch) => {
    try {
      const entitlementsJSONData = await dispatch(entitlements())
      await dispatch(fetchEntitlementsSuccess(entitlementsJSONData))
    } catch(err) {
      await dispatch(dataFailure(err.message))
    }
  }
}

const updateEntitlementData = (values) => {
  return {
    type: UPDATE_PERSON_ENTITLEMENT,
    payload: values
  }
}

export const updateEntitlement = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(entitlementUpdate(values));
      await dispatch(updateEntitlementData(values))
      await dispatch(dataSuccess())
    } catch(err) {
      await dispatch(dataFailure(err.message));
      
    }
  }
}

const cancelEntitlementData = (values) => {
  return {
    type: CANCEL_PERSON_ENTITLEMENT,
    payload: values
  }
}

export const cancelEntitlement = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(entitlementCancel(values));
      await dispatch(cancelEntitlementData(values))
      await dispatch(dataSuccess())
    } catch(err) {
      await dispatch(dataFailure(err.message));
    }
  }
}

export const addEntitlementData = (values) => {
  return {
    type: ADD_PERSON_ENTITLEMENT,
    payload: values
  }
}

export const addEntitlement = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(entitlementAdd(values));
      await dispatch(addEntitlementData(values))
      await dispatch(dataSuccess())
    } catch(err) {
      await dispatch(dataFailure(err.message));
      
    }
  }
}

const deleteEntitlementData = (values) => {
  return {
    type: DELETE_PERSON_ENTITLEMENT,
    payload: values
  }
}

export const deleteEntitlement = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(entitlementDelete(values));
      await dispatch(deleteEntitlementData(values))
      await dispatch(dataSuccess())
    } catch(err) {
      await dispatch(dataFailure(err.message));
      
    }
  }
}

export const setEntitlementId = (id) => {
  return {
    type: SET_ENTITLEMENT_ID,
    payload: id
  }
}

export const resetEntitlement = () => {
  return {
    type: RESET_ENTITLEMENT
  }
}